import { render, staticRenderFns } from "./DouYinVideo.vue?vue&type=template&id=bc8345aa&scoped=true"
import script from "./DouYinVideo.vue?vue&type=script&lang=js"
export * from "./DouYinVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8345aa",
  null
  
)

export default component.exports